export default "__VITE_ASSET__BZUHp7jO__"